import ToolBase from '../basic';
import DEFINE from '../define';

export default class Arrow extends ToolBase {

    name = DEFINE.TOOLS.ARROW;

    setting = null;
    arrow = null;
    isDown = null;
    origX = null;
    origY = null;

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        object.set({
            lockMovementX: true,
            lockMovementY: true,
            hasControls: false,
            hasBorders: false
        })
    }

    mouseUp(o) {
        this.isDown = false;

        this.parent.addHistory();
    }

    mouseDown(o) {
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.LINE_SEGMENT);
        this.isDown = true;
        this.arrow = null;
        this.origX = pointer.x;
        this.origY = pointer.y;
    }

    mouseMove(o) {
        if (!this.isDown) return;
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));
        let angle = 90 - Math.atan2((pointer.x - this.origX), (pointer.y - this.origY)) * (180 / Math.PI);
        let distance = Math.sqrt(Math.pow((this.origX - pointer.x), 2) + Math.pow((this.origY - pointer.y), 2));
        let realWidth = this.setting.strokeWidth / 2;

        if (this.arrow) {
            this.canvas.remove(this.arrow);
        }

        // 箭頭
        const maxDistance = Math.max(0, distance - (2.5 * realWidth));
        let arrowPoints = [
            {
                x: this.origX,
                y: this.origY
            },
            {
                x: this.origX,
                y: this.origY - (realWidth / 2)
            },
            {
                x: this.origX + (0.5 * realWidth) + maxDistance,
                y: this.origY - (realWidth / 2)
            },
            {
                x: this.origX + (-0.7 * realWidth) + maxDistance,
                y: this.origY - (1.8 * realWidth)
            },
            {
                x: this.origX + maxDistance,
                y: this.origY - (2.5 * realWidth)
            },
            {
                x: this.origX + (2.5 * realWidth) + maxDistance,
                y: this.origY
            },
            {
                x: this.origX + maxDistance,
                y: this.origY + (2.5 * realWidth)
            },
            {
                x: this.origX + (-0.7 * realWidth) + maxDistance,
                y: this.origY + (1.8 * realWidth)
            },
            {
                x: this.origX + (0.5 * realWidth) + maxDistance,
                y: this.origY - (-realWidth / 2)
            },
            {
                x: this.origX,
                y: this.origY - (-realWidth / 2)
            },
            {
                x: this.origX,
                y: this.origY
            }
        ]

        this.arrow = new fabric.Polygon(arrowPoints, {
            tag: DEFINE.TAG.ARROW + new Date().getTime(),
            toolType: this.name,
            angle: angle,
            opacity: this.setting.opacity,
            fill: this.setting.fill,
            stroke: this.setting.stroke,
            strokeWidth: realWidth,
            transparentCorners: false,
            selectable: true,
            hasControls: false,
            hasBorders: false,
            lockMovementX: true,
            lockMovementY: true,
            perPixelTargetFind: true,
            borderColor: "rgba(0, 0, 0, 0)",
            originX: "left",
            originY: "center"
        });

        this.arrow.setCoords();
        this.canvas.add(this.arrow).renderAll();
    }
}